import React, {useContext} from 'react'
import { EditedContext } from '../../../../partials/Context'

function Phone({ phone_sms }) {
    const edited = useContext(EditedContext);
    const {edited_item, input_value, setInputValue, changeBtn} = edited || ''
  return (
    <div className="phone-number highlight">
        <span>Dodaj numer telefonu do powiadomień sms, by jeszcze szybciej odpowiadać klientom, chcącym skorzystać z&nbsp;Twoich usług&nbsp; +48&nbsp;&nbsp;</span>
        {edited_item === 'phone_sms' ? 
            <input type="text" className="form-input" value={input_value.phone_sms} onChange={
                (e)=>setInputValue({phone_sms: e.target.value})}/>
            :
            <span id="company-name">{phone_sms ? phone_sms.slice(-9) : '-'}</span>
        }
        {changeBtn('phone_sms')
    }
    </div>
  )
}

export default Phone